import { Tabs } from "antd";
import { BaseComponent } from "../../components/infrastructure/baseComponent";
import CustomSpinner from "../../components/infrastructure/customSpinner";
import { ICallOptions, IResultSet } from "../../components/infrastructure/models";
import { IProfile, IProfileProps, IProfileStates } from "./interfaces";
import * as AllComponents from '../../home/components';
import { enmEntityManagerState } from "../../components/entityManager/interfaces";
import React from "react";
import { UserEdit } from "./userEdit";
import { Redirect } from "react-router-dom";
import AppContext, { AppContextProps } from "../../components/infrastructure/appContext";
const { TabPane } = Tabs;

export class Profile extends BaseComponent<IProfileProps, IProfileStates> {
    static contextType = AppContext;
    constructor(props: IProfileProps) {
        super(props)

        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchProfileInfo();
    }
    async fetchProfileInfo() {
        let fetchOpt: ICallOptions = {
            url: "user/getprofileinfo",
            onSuccess: (result) => {
                let res = result as IResultSet<IProfile>;
                if (res.ValidationState.Successful)
                    this.setState({ profile: res.Data });
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    virtualRender() {
        const header = this.getPageHeader({ title: "پروفایل", onBack: () => window.history.back() });

        let extraTabs: React.ReactNode[] = [];

        const { getMenuItems } = this.context as AppContextProps;
        const menuItems = getMenuItems();

        this.state.profile?.Relations.forEach(r => {
            const Component = (AllComponents as any)[r.Source];
            let currentMenu = menuItems.find(c => c.Item === r.Source);
            extraTabs.push(
                <TabPane
                    tab={
                        <span>
                            {currentMenu?.Title}
                        </span>
                    }
                    key={`${r.Source}_${r.SourceId}`}
                >
                    <Component showHeader={false} dataformBoxShadow={false} defaultId={r.SourceId} defaultState={enmEntityManagerState.View} />
                </TabPane>
            );
        });

        if (!this.state.profile && !this.state.loading)
            return <Redirect to={'/'} />;

        return (
            <>
                {header}
                <div>
                    <Tabs className="box" defaultActiveKey="1">
                        <TabPane
                            tab={
                                <span style={{ marginRight: 4 }}>
                                    اطلاعات کاربری
                                </span>
                            }
                            key="User"
                        >
                            {this.state.profile ? <UserEdit currentUser={this.state.profile.User} /> : <CustomSpinner />}
                        </TabPane>
                        {extraTabs}
                    </Tabs>
                </div>
            </>
        );
    }
}